import React from 'react';
import { Badge } from '@/components/ui/badge';

const UserStatus = ({ status }) => {
    let variant = 'default';

    const capFirstLetterAndLowerCaseRest = (str) => {
        if (!str) return str; // Handle empty/null/undefined input
        return `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
    };

    switch (status) {
        case 'active':
            variant = 'default';
            break;
        case 'inactive':
            variant = 'destructive';
            break;
        case 'invited':
            variant = 'outline'; // You must define this in your badge variant styles
            break;
        default:
            variant = 'secondary';
    }

    return (
        <Badge variant={variant}>
            {capFirstLetterAndLowerCaseRest(status)}
        </Badge>
    );
};

export default UserStatus;
